/**********代码高亮*************/
//高亮代码显示
function qkHighlightjs(){
    
    if(!qk_global.highlightjs_show) return;
    
	let pres =  document.getElementsByTagName('pre'); //替换标签class
	if(typeof(pres) == "object"){
	    Array.from(pres).forEach( (pre) => {
	        
	        if (pre.className.indexOf('qk-highlightjs') <= -1){
                pre.classList.add("qk-highlightjs");
            }
            
            if (pre.className.indexOf('line-numbers') <= -1){
                pre.classList.add("line-numbers");
            }
            
            if (!pre.className.match(/(\w+)-theme/)){
                pre.classList.add(qk_global.highlightjs_theme + "-theme");
            }
        });
	}
}

export default qkHighlightjs;
